import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { ACCESS_TOKEN } from "../helpers/constants";
import { fetchUserId, fetchCompanyId } from '../helpers/CompanyId';
import Footer from '../components/common/Footer';
import Navbar from './Navbar';
import '../styles/Home.css';
import api from "../api";


const Home = () => {
  const [showRegisterDropdown, setShowRegisterDropdown] = useState(false);
  const [showSetupDropdown, setShowSetupDropdown] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [error, setError] = useState(null);

  const navigate = useNavigate();



  useEffect(() => {
    const fetchUserRole = async () => {
      const token = localStorage.getItem(ACCESS_TOKEN);
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken.user_id;
          const roleName = decodedToken.role;
          console.log("RNMAE:",roleName)
          console.log("ID:",userId)
          setUserRole(roleName);
        } catch (error) {
          console.error('Error fetching user role:', error);
        }
      }
    };
    fetchUserRole();
  }, [navigate]);
  
 
  const checkCompany = async () => {
    try {
      const userId = await fetchUserId();
      if (!userId) {
        setError("User ID not found");
        return;
      }
  
      console.log("SUV:", userId);

      
  
      const companyId = await fetchCompanyId(userId);
      if (!companyId) {
        console.log("No company found for this user. Redirecting to setup.");
        navigate("/companysetup");
        return;
      }
  
      console.log("SS:", companyId);
  
      // Fetch company details if companyId exists
      const response = await api.get("/api/getcompanydetails/");
      if (response.data) {
        navigate("/companydetails");
      } else {
        navigate("/companysetup");
      }
    } catch (error) {
      console.error("Error checking company:", error);
      setError("An error occurred while checking the company.");
    }
  };
  
  const handleCompanySetupClick = () => {
    checkCompany();
  };
  

  const handleSetupClick = () => {
    setShowSetupDropdown(!showSetupDropdown);
    setShowRegisterDropdown(false); // Close Register dropdown if open
  };

  const handleRegisterClick = () => {
    setShowRegisterDropdown(!showRegisterDropdown);
    setShowSetupDropdown(false); // Close Setup dropdown if open
  };

  const handleNavigate = (path) => {
    navigate(path);
    // setShowDropdown(false);
  };

  const renderLinks = () => {
    if (userRole === 'Super Admin') {
      return (
        <ul>
          <li><a href="/createrole">Create Roles</a></li>
          <li><a href="/adminregister">Register Users</a></li>
        </ul>
      );
    }

    if (userRole === 'Admin' || userRole === 'Account Manager' || userRole === 'XYZ') {
      return (
        <ul>
          {/* <li><a href="/register">Register Users</a></li> */}
          <li className="dropdown">
            <a href="#" onClick={handleRegisterClick}>Register Users</a>
            {showRegisterDropdown && (
              <ul className="simple-dropdown">
                <li style={{ paddingLeft: '20px' }}><a href="#" onClick={() => handleNavigate('/createrole')}>Create Roles</a></li>
                <li style={{ paddingLeft: '20px' }}><a href="#" onClick={() => handleNavigate('/adminregister')}>Admin/Account Manager</a></li>
                <li style={{ paddingLeft: '20px' }}><a href="#" onClick={() => handleNavigate('/employeeregister')}>Employees</a></li>
              </ul>
            )}
          </li>
          <li><a href="#" onClick={handleCompanySetupClick}>Company Setup</a></li>
          <li className="dropdown">
            <a href="#" onClick={handleSetupClick}>SetUp</a>
            {showSetupDropdown && (
              <ul className="simple-dropdown">
                <li style={{ paddingLeft: '20px' }}><a href="#" onClick={() => handleNavigate('/payroleset')}>Payroll Setup</a></li>
                <li style={{ paddingLeft: '20px' }}><a href="#" onClick={() => handleNavigate('/employeesetup')}>Employee Setup</a></li>
              </ul>
            )}
          </li>
          <li><a href="/employeelist">Employee List</a></li>
          <li><a href="/biometric">Biometric Attendance</a></li>
          <li><a href="/attendance">Attendance</a></li>
          <li><a href="/Validation">Pay Slip</a></li>
        </ul>
      );
    }

    if (userRole === 'Employee') {
      return (
        <ul>
          <li><a href="/employeedetails">Profile</a></li>
        </ul>
      );
    }

    return null;
  };

  return (
    <div>
      <Navbar />
      <div className="page-container">
        <div className="dashboard-box">
          {renderLinks()}
        </div>
        <div className="content-box">
          <h1>Welcome to the HRMS</h1>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;

